module.exports = __webpack_public_path__ + "static/media/lon_con_per_che.789147f7.png";